import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export const ThemeContext = React.createContext(null);
const ThemeProvider = ({ theme, children }) => (_jsx(ThemeContext.Provider, Object.assign({ value: { theme } }, { children: children })));
export default ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map